import React, { Component } from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import isEmpty from 'lodash/isEmpty';
import 'whatwg-fetch';

import { Block, Subpages, Link } from '../partials/index';
import Logo from '../blocks/Logo';

const propTypes = {
    title: PropTypes.string,
    pathname: PropTypes.string,
    blocks: PropTypes.array,
    id: PropTypes.number,
};

const defaultProps = {
    title: 'characters',
    slug: 'large',
    pathname: null,
    blocks: [],
    id: null,
};

class BlogLayout extends Component {
    constructor(props) {
        super(props);

        this.onClickMonth = this.onClickMonth.bind(this);

        this.state = {
            news: null,
            month: null,
            category: null,
        };
    }

    componentDidMount() {
        this.fetchNews();
    }

    onClickMonth(e, month, category) {
        e.preventDefault();
        if (this.state.month === month && this.state.category === category) {
            this.setState({
                month: null,
                category: null,
            });
            return;
        }
        this.setState({
            month,
            category,
        });
    }

    getMonthsByCategory(category) {
        const { news } = this.state;
        if (news === null) {
            return [];
        }
        const categoryPages = news.filter(page => (
            (
                (typeof page.category === 'undefined' || isEmpty(page.category)) &&
                category === 'news'
            ) || (
                typeof page.category !== 'undefined' &&
                page.category === category
            )
        ));
        const months = [];
        categoryPages.forEach((page) => {
            const month = moment(page.created_at).format('YYYY-MM-01');
            if (months.indexOf(month) === -1) {
                months.push(month);
            }
        });
        return months;
    }

    fetchNews() {
        const { id } = this.props;
        fetch(`/api/pages/${id}/children`)
            .then(response => response.json())
            .then((news) => {
                this.setState({
                    news,
                });
            });
    }

    renderMonths(months, category) {
        const { pathname } = this.props;
        return (
            <ul>
                { months.map(month => (
                    <li
                        key={`date-${month}`}
                        className={this.state.month === month && this.state.category === category ? 'active' : null}
                    >
                        <Link
                            to={pathname}
                            onClick={e => this.onClickMonth(e, month, category)}
                        >{ moment(month).format('MMMM YYYY') }</Link>
                    </li>
                )) }
            </ul>
        );
    }

    render() {
        const { title, blocks, pathname } = this.props;
        const { month, news, category } = this.state;

        if (news === null) {
            return null;
        }

        const filteredNews = news.filter(page => (
            (
                month === null ||
                moment(page.created_at).format('YYYY-MM-01') === month
            ) && (
                category === null || ((
                    (typeof page.category === 'undefined' || isEmpty(page.category)) &&
                    category === 'news'
                ) || (
                    typeof page.category !== 'undefined' &&
                    page.category === category
                ))
            )
        ));

        const newsMonths = this.getMonthsByCategory('news');
        const screeningsMonths = this.getMonthsByCategory('screenings');
        return (
            <div className="layout layout-with-cols layout-blog">
                <div className="cols">
                    <div className="col">
                        <h1 className="title page-title">{title}</h1>
                        <Block blocks={blocks || []} />
                        <Subpages pages={filteredNews} pathname={pathname} />
                    </div>
                    <div className="col col-very-small">
                        <div className="col-inner">
                            <Logo />
                            <h4 className="subtitle">Archive</h4>
                            { newsMonths !== null && newsMonths.length > 0 ? (
                                <div className="archive-section">
                                    <h4 className="subtitle color-black">News</h4>
                                    { this.renderMonths(newsMonths, 'news') }
                                </div>
                            ) : null }
                            { screeningsMonths !== null && screeningsMonths.length > 0 ? (
                                <div className="archive-section">
                                    <h4 className="subtitle color-black">Screenings</h4>
                                    { this.renderMonths(screeningsMonths, 'screenings') }
                                </div>
                            ) : null }
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

BlogLayout.propTypes = propTypes;
BlogLayout.defaultProps = defaultProps;

export default BlogLayout;



// WEBPACK FOOTER //
// ./components/layouts/BlogLayout.jsx